import React from 'react'
import { Navigate } from 'react-router'
import { useNavigationContext } from 'components/Utility/NavigationContext/NavigationContext'

type RedirectProps = {
  to: string,
  status: number,
}

/** Client: navigates. Server: the SSR handler answers with this status and Location */
export const Redirect: React.FC<RedirectProps> = (props) => {
  const { to, status } = props
  const navigationContext = useNavigationContext()
  navigationContext.status = status
  navigationContext.href = to
  return <Navigate to={to} replace />
}
